import API from "Helpers/API";

class AppService {
  api: API;

  constructor(api: API) {
    this.api = api;
  }

  public getAppInfo() {
    return this.api.get({
      location: `/appInfo`,
      params: "",
    });
  }
}

export default AppService;
